import React, { useMemo } from 'react';
import {
  SidebarWrapper,
  AvatarWrapper,
  Avatar,
  SidebarMenu,
  Tab,
  StyledArrowRightIcon,
  EmptyAvatar,
  UserNameInfo,
} from './styles';
import Text, { TEXT_COLOR } from '@components/Text';
import { ROUTES } from '@shared/constants';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import { NO_NAME, TABS } from '../../../consts';
import { useSelector } from 'react-redux';
import { getAgeAndEmailText } from '../../../helpers';

/**
* Sidebar for all internal pages on the right side
* @param {string} pageType - page type
*/
export const Sidebar = ({ pageType }) => {
  const { id } = useParams();
  const { state } = useLocation();

  const { avatar, fullName, email, birthdate } = useSelector((state) => state.getIn(['userPage', 'userData']));
  const ageAndEmailText = getAgeAndEmailText({ email, birthdate });
  const { roles: userRoles } = useSelector((state) => state.getIn(['app', 'authentication', 'user']).toJS());
  const firstLettersName = useMemo(() =>
    fullName && fullName.split(' ').map((name) => name.at(0))
  , [fullName]);

  return (
    <SidebarWrapper>
      <AvatarWrapper>
        {avatar
          ? <Avatar src={avatar} alt={`${fullName ?? NO_NAME}`} />
          : <EmptyAvatar>{firstLettersName}</EmptyAvatar>
        }
        <UserNameInfo>
          <Text size="H1" textColor={TEXT_COLOR.DARK_BLUE}>
            {fullName ?? NO_NAME}
          </Text>
          {ageAndEmailText && (
            <Text size="T4" textColor={TEXT_COLOR.DISABLED}>
              {ageAndEmailText}
            </Text>
          )}
        </UserNameInfo>
      </AvatarWrapper>
      <SidebarMenu>
        {TABS.map(({ type, title, roles }) => (
          roles && !roles.some((role) => userRoles.includes(role)) ? null : (
            <Tab
              to={{
                pathname: generatePath(ROUTES.USERS.PAGE, { id, pageType: type }),
                state,
              }}
              active={pageType === type}
            >
            {title}
          {pageType === type && <StyledArrowRightIcon />}
        </Tab>
        )))}
      </SidebarMenu>
    </SidebarWrapper>
  );
};
